import React, { Component } from "react";

import "./BulkDragAndDrop.scss";

import folderPrimary from "../../../assets/folders/folder_primary.svg";

class DragAndDrop extends Component {
  state = {
    drag: false,
  };
  dropRef = React.createRef();
  inputId = `browseBulkUpload${Math.random(5)}`;

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let div = this.dropRef.current;

    div.setAttribute("style", "background-color: #f1f1f1");
  };
  handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  };
  handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ drag: false });
    }

    let div = this.dropRef.current;

    div.setAttribute("style", "background-color: #fff");
  };
  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }

    let div = this.dropRef.current;

    if(div)
    {
      div.setAttribute("style", "background-color: #fff");
    }
  };

  changeBrowseInput = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.props.handleDrop(e.target.files);
    }
  };

  componentDidMount() {
    let div = this.dropRef.current;
    div.addEventListener("dragenter", this.handleDragIn);
    div.addEventListener("dragleave", this.handleDragOut);
    div.addEventListener("dragover", this.handleDrag);
    div.addEventListener("drop", this.handleDrop);
  }
  componentWillUnmount() {
    let div = this.dropRef.current;
    div.removeEventListener("dragenter", this.handleDragIn);
    div.removeEventListener("dragleave", this.handleDragOut);
    div.removeEventListener("dragover", this.handleDrag);
    div.removeEventListener("drop", this.handleDrop);
  }

  render() {
    return (
      <div
        id={this.props.id ?? Math.random(5)}
        className={`mt-6 py-4 d-flex upload-file-container${!this.props.isSubFileSelector ? `-full-width` : ` `} align-items-center`}
        ref={this.dropRef}
      >
        <div className="upload-file-icon">
          <img src={folderPrimary} alt="folder primary" className="img-fluid" />
        </div>
        <div className="mt-1 d-flex upload-file-title">
          <div className="upload-file-title-item">
            Drag and drop your {this.props.isSubFileSelector ? `sub-file(s)` : `file`} or{" "}
            <input
              type="file"
              name="file"
              id={this.inputId}
              className="browse-bulk-upload"
              accept=".pdf, .xls, xlsx, .csv, .doc, .docx"
              onClick={(e) => {
                e.target.value = null;
              }}
              multiple
              onChange={this.changeBrowseInput}
            />
            <label htmlFor={this.inputId} className="d-inline-block">
              <span className="upload-file-title-browse">Browse</span>
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default DragAndDrop;
